package com.havn.app.core.media

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import coil3.compose.AsyncImage

@Composable
fun HavnAsyncImage(
    dataUrl: String?,
    contentDescription: String?,
    modifier: Modifier,
    contentScale: ContentScale = ContentScale.Crop
): Boolean {
    val source = dataUrl?.takeIf { it.isNotBlank() } ?: return false
    AsyncImage(
        model = source,
        contentDescription = contentDescription,
        modifier = modifier,
        contentScale = contentScale
    )
    return true
}
